export const GET_PRODUCT_LIST_START = '@products/GET_PRODUCT_LIST_START'
export const GET_PRODUCT_LIST_SUCCESS = '@products/GET_PRODUCT_LIST_SUCCESS'
export const GET_PRODUCT_LIST_FAILURE = '@products/GET_PRODUCT_LIST_FAILURE'

export const SELECT_DOCUMENT = '@products/SELECT_DOCUMENT'
export const SELECT_ALL_DOCUMENTS = '@products/SELECT_ALL_DOCUMENTS'

export const GET_PRODUCT_START = '@products/GET_PRODUCT_START'
export const GET_PRODUCT_FINISH = '@products/GET_PRODUCT_FINISH'

export const GET_MERGED_PRODUCTS_START = '@products/GET_MERGED_PRODUCTS_START'
export const GET_MERGED_PRODUCTS_SUCCESS = '@products/GET_MERGED_PRODUCTS_SUCCESS'
export const GET_MERGED_PRODUCTS_FAILURE = '@products/GET_MERGED_PRODUCTS_FAILURE'

export const GET_ZIPPED_PRODUCTS_START = '@products/GET_ZIPPED_PRODUCTS_START'
export const GET_ZIPPED_PRODUCTS_SUCCESS = '@products/GET_ZIPPED_PRODUCTS_SUCCESS'
export const GET_ZIPPED_PRODUCTS_FAILURE = '@products/GET_ZIPPED_PRODUCTS_FAILURE'

export const GET_EFF_START = '@products/GET_EFF_START'
export const GET_EFF_SUCCESS = '@products/GET_EFF_SUCCESS'
export const GET_EFF_FAILURE = '@products/GET_EFF_FAILURE'


// WEBPACK FOOTER //
// ./src/screens/briefing/products/actions/types.js